import * as React from 'react'

function areRowsEqual<T extends object>(
  previous: readonly T[],
  current: readonly T[],
): boolean {
  if (previous.length !== current.length) return false

  return previous.every((previousRow, index) => {
    const currentRow = current[index]
    if (!currentRow) return false

    const keys = Object.keys(previousRow) as Array<keyof T>
    return (
      keys.length === Object.keys(currentRow).length &&
      keys.every(key => {
        const previousValue = previousRow[key]
        const currentValue = currentRow[key]
        if (
          (typeof previousValue === 'object' && previousValue !== null) ||
          (typeof currentValue === 'object' && currentValue !== null)
        ) {
          return false
        }
        return Object.is(previousValue, currentValue)
      })
    )
  })
}

export function useStableRows<T extends object>(rows: T[]): T[] {
  const ref = React.useRef(rows)
  if (!areRowsEqual(ref.current, rows)) {
    ref.current = rows
  }
  return ref.current
}
